/**
 * AI yanıtlarının Markdown gösterimi.
 *
 * Masaüstü panel Markdig kullanıyor; tarayıcıda `marked` aynı işi yapıyor. Çıktı HTML
 * olduğu için DOMPurify'dan geçiyor: metin modelden geliyor ve içine gömülü bir şeyin
 * çalışmasına gerek yok. Bağlantılar yeni sekmede ve `noopener` ile açılıyor.
 *
 * Kod blokları olduğu gibi bırakılıyor (kopyalama düğmesini arayüz ekliyor); ```html
 * blokları ise metinden ÇIKARILIYOR (bkz. artifacts) — rapor kart olarak gösteriliyor.
 */
import { marked } from 'marked';
import DOMPurify from 'dompurify';

marked.setOptions({
  gfm: true,
  breaks: true,
});

/** Markdown → güvenli HTML. */
export function renderMarkdown(text: string): string {
  if (!text) return '';
  const html = marked.parse(text, { async: false }) as string;
  return DOMPurify.sanitize(html, {
    USE_PROFILES: { html: true },
    ADD_ATTR: ['target', 'rel'],
  });
}

/**
 * Akış sırasında ÇİZİLEN metin.
 *
 * Yarım kalmış Markdown (kapanmamış kod bloğu, yarım tablo) her parçada yeniden
 * ayrıştırılınca satırlar zıplıyor ve tablo yarım çiziliyordu. Akarken düz metin
 * gösteriliyor, yanıt bitince bir kez Markdown'a çevriliyor — masaüstü paneli de
 * aynı yolu izliyor.
 */
export function streamingText(text: string): string {
  return text;
}

/** Kopyalama için: HTML değil kaynak metin. */
export function plainText(text: string): string {
  return text;
}
